import { useContext } from 'react';
import { Typography, Stepper, Step, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import { Analytics } from 'lib/api';
import { KYX_ANALYTICS_EVENTS } from './StartKYX';

import { ReactComponent as Group98 } from '../../assets/modalKYX/Group98.svg';
import { ReactComponent as Group99 } from '../../assets/modalKYX/Group99.svg';

import { ReactComponent as CardDouble } from '../../assets/modalKYX/Card_double.svg';
import { AuthContext } from 'context/auth-context';

const useStyles = makeStyles({
    banner: {
        backgroundColor: '#182D55 !important',
        maxWidth: '16em',
        minHeight: '100%',
        paddingTop: '3em'
    },
    dialogBody: {
        display: 'flex',
        flexDirection: 'row',
        minHeight: '600px',
        height: '100%'
    },
    bannerTitle: {
        color: 'white',
        fontWeight: '700!important'
    },
    bannerSpan: {
        color: 'white'
    },
    bannerText: {
        margin: '1em'
    },
    dialogContent: {
        backgroundColor: 'transparent!important',
        padding: '0!important',
        minHeight: '600px',
        minWidth: '64em'
    },
    content: {
        margin: '2em',
        width: '40em'
    },
    contentTitle: {
        fontWeight: '700!important'
    },
    verifyOption: {
        borderRadius: '15px',
        border: '1px solid #d4d4d4',
        padding: '2em 1em',
        display: 'flex',
        flexDirection: 'row',
        paddingRight: '36px',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    verifyText: {
        maxWidth: '30em'
    },
    verifyTitle: {
        fontWeight: '700!important'
    },
    startKYX: {
        color: 'white!important',
        borderRadius: '25px!important',
        marginLeft: '1em',
        padding: '.5em 1em!important'
    },
    doItLater: {
        marginTop: '10em'
    }
});

export const KYXFirstStep = ({ handleClose, incrementPage, openModalKYB }) => {
    const classes = useStyles();

    const { userInfo, businessInfo } = useContext(AuthContext);

    const hasKYC = ['started', 'approved', 'review', 'declined'].includes(userInfo?.kyc);

    const hasKYB = !!userInfo?.kyb && businessInfo?.owners?.length > 0 && businessInfo?.banks?.length > 0;

    const startKYC = () => {
        const body = {
            step: KYX_ANALYTICS_EVENTS.STEP_1
        };
        Analytics.createKYXEvent(body).catch(error => console.error(error));
        incrementPage();
    };

    return (
        <Box className={classes.dialogBody}>
            <Box
                className={classes.banner}
                sx={{
                    display: { lg: 'initial', md: 'initial', sm: 'none', xs: 'none' }
                }}>
                <CardDouble />
                <Box className={classes.bannerText}>
                    <Typography variant="h5" component="h5" className={classes.bannerTitle}>
                        Welcome to the Paystand DeFi Corporate Card!
                    </Typography>
                    <Typography className={classes.bannerSpan}>
                        Manage all of your expenses with virtual cards that work exactly like credit cards, and give you reward
                        points in bitcoin.
                    </Typography>
                </Box>
            </Box>
            <Box className={classes.content}>
                <Typography variant="h6" className={classes.contentTitle}>
                    Complete KYC and KYB
                </Typography>
                <Typography variant="subtitle1">
                    You need to verify yourself and your business to unlock all the features of the Paystand DeFi Corporate Card
                </Typography>
                <Stepper className={classes.stepper} activeStep={1} orientation="vertical">
                    <Step key={1}>
                        <Box className={classes.verifyOption} style={{ marginTop: '1em' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                <Group98 style={{ marginRight: '1em' }} />
                                <Box className={classes.verifyText}>
                                    <Typography variant="body1" className={classes.verifyTitle}>
                                        1. Verify Yourself
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        className={classes.verifyBody}
                                        sx={{
                                            maxWidth: {
                                                lg: '65%',
                                                md: '65%',
                                                sm: '90%',
                                                xs: '90%'
                                            }
                                        }}>
                                        We will take you through a series of steps to verify your identity.
                                    </Typography>
                                </Box>
                            </Box>
                            <Button variant="contained" disabled={hasKYC} onClick={() => startKYC()} sx={{ width: '175px' }}>
                                Start KYC
                            </Button>
                        </Box>
                    </Step>
                    <Step key={2}>
                        <Box className={classes.verifyOption}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                <Group99 style={{ marginRight: '1em' }} />
                                <Box className={classes.verifyText}>
                                    <Typography variant="body1" className={classes.verifyTitle}>
                                        2. Verify Your Business
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        className={classes.verifyBody}
                                        sx={{
                                            maxWidth: {
                                                lg: '65%',
                                                md: '65%',
                                                sm: '90%',
                                                xs: '90%'
                                            }
                                        }}>
                                        We will take you through a series of steps to verify your identity.
                                    </Typography>
                                </Box>
                            </Box>
                            <Button
                                disabled={!hasKYC || hasKYB}
                                variant="contained"
                                onClick={openModalKYB}
                                sx={{ width: '175px' }}>
                                Start KYB
                            </Button>
                        </Box>
                    </Step>
                </Stepper>
                <Box className={classes.doItLater}>
                    <Button style={{ color: '#0645AD', textTransform: 'none' }} onClick={() => handleClose()}>
                        I will do it later
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};
